import tw, { css } from 'twin.macro'

export const getHoverStyles = (hoverColor: string) => css`
  &:hover div div {
    background-color: ${hoverColor};
  }
`

const getSingleProductStyles = () => css`
  width: 100%;
  max-width: 830px;
`

export const getVariantStyles = (variant: 'single-product' | 'default') => {
  switch (variant) {
    case 'single-product':
      return getSingleProductStyles()
    case 'default':
      return undefined
    default:
      return undefined
  }
}

export const getTitleAlignmentStyles = (alignment: 'left' | 'center') => {
  switch (alignment) {
    case 'left':
      return css`
        & {
          ${tw`grid-cols-[1fr_3rem]`}
        }

        p {
          ${tw`text-left`}
        }
      `
    case 'center':
      return tw`grid-cols-[3rem_1fr_3rem]`
    default:
      return undefined
  }
}

const getTextAlignmentSpecificStyles = (alignment: 'left' | 'center', isOpen: boolean) => {
  switch (alignment) {
    case 'left':
      return css`
        ${tw`px-6 text-left`}
        ${isOpen && tw`px-4 sm:px-8`}
      `
    case 'center':
      return css`
        ${tw`px-6 text-center`}
        ${isOpen && tw`px-6`}
      `
    default:
      return undefined
  }
}

export const getTextAlignmentStyles = (alignment: 'left' | 'center', isOpen: boolean) => css`
  ${tw`font-body text-inherit h-auto grid grid-rows-[0fr] transition-all duration-500`}
  ${isOpen && tw`pb-8 pt-2.5 grid-rows-[1fr]`}
  ${getTextAlignmentSpecificStyles(alignment, isOpen)}
`
